import axios from "axios";
import { routes } from "../../General";

const endpoint = `${routes.apiGen}/tarjetas/`;

export const getTarjetaByCedula = async cedula => {
    return getTarjeta("asegurado", { cedula });
};
export const getTarjetaByCdCliente = async cdCliente => {
    return getTarjeta("cliente", { cdCliente });
};

const getTarjeta = async (module, params) => {
    const { data } = await axios.get(endpoint + module, { params });
    return data;
};
